import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconUserDeleteComponent } from "./med-icon-user-delete.component";

@NgModule({
  declarations: [
    MedIconUserDeleteComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconUserDeleteComponent,
  ],
})
export class MedIconUserDeleteModule { }
